import {Component, Inject, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfService} from '../../../conf.service';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {KongService} from '../../../kong.service';
import {LeftpanelNewComponent} from '../../../leftpanel-new/leftpanel-new.component';
import {MatChipInputEvent} from '@angular/material/chips';
import {
  AssociateWithGroupComponent,
  DialogData, VerifyCredentialsComponent
} from '../../../gateway-consumer/create-credential-dialog/create-credential-dialog.component';

export interface DialogData {
  Topic: any;
  type: any;
  jwtResponse: any | null;
  attributes: [
    {
      name: any,
      description: any,
      option: any
    }
  ];
  id: any;
  partnerName: any;
}

@Component({
  selector: 'app-create-consumer-dialog',
  templateUrl: './create-consumer-dialog.component.html',
  styleUrls: ['./create-consumer-dialog.component.scss']
})
export class CreateConsumerDialogComponent implements OnInit {

  formResponse = {};
  jwtAlgorithms = ['HS256', 'RS256'];
  selectedJWTAlgo = 'HS256';
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  chipItems = [];
  chipList: any;
  accountName: any;

  constructor(
      public dialogRef: MatDialogRef<CreateConsumerDialogComponent>,
      public confPost: ConfService,
      public dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      private kongService: KongService,
      private _snackBar: MatSnackBar,
      public platform: LeftpanelNewComponent) {
  }

  ngOnInit() {
    const temp = localStorage.getItem('partner').split('-');
    this.accountName = temp[temp.length - 1];
    if (this.data.attributes.length > 0) {
      for (const attribute of this.data.attributes) {
        this.formResponse[attribute['name']] = '';
      }
    }
  }



  postKongDetails(id, payload, type) {
    this.kongService.postKongGatewayAPIkeyDetails(id, payload, type).subscribe(response => {
      if (response) {
        this.dialogRef.close(type);
        this.platform.openSnackBar('New ' + type + ' created', 'Success', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }, error => {
      this.platform.openSnackBar('Error while creating the credential: ' + error['error']['name'], 'Error', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  createCredential(type) {

    switch (type) {
      case 'key-auth':
        for (const attr of this.data.attributes) {
          if (this.formResponse[attr['name']] === '') {
            delete this.formResponse[attr['name']];
          }
        }
        this.postKongDetails(this.data['id'], this.formResponse, type);
        break;
      case 'jwt':
        for (const attr of this.data.attributes) {
          if (this.formResponse[attr['name']] === '') {
            delete this.formResponse[attr['name']];

          }
        }
        this.formResponse['algorithm'] = this.selectedJWTAlgo;
        this.postKongDetails(this.data['id'], this.formResponse, type);
        break;
      case 'oauth2':
        for (const attr of this.data.attributes) {
          if (this.formResponse[attr['name']] === '') {
            delete this.formResponse[attr['name']];
          }
        }
        this.formResponse['redirect_uris'] = this.chipItems;
        this.postKongDetails(this.data['id'], this.formResponse, type);
        break;
      case 'basic-auth':
        for (const attr of this.data.attributes) {
          if (this.formResponse[attr['name']] === '') {
            delete this.formResponse[attr['name']];
          }
        }
        this.postKongDetails(this.data['id'], this.formResponse, type);
        break;
      case 'hmac-auth':
        for (const attr of this.data.attributes) {
          if (this.formResponse[attr['name']] === '') {
            delete this.formResponse[attr['name']];
          }
        }
        this.postKongDetails(this.data['id'], this.formResponse, type);
        break;
      case 'acls':
        this.formResponse['group'] = this.formResponse['Group name'];
        delete this.formResponse['Group name'];
        const groupSplit = this.formResponse['group'].split(':');
        const split = groupSplit[0].split('-');
        if (split.length === 1) {
          if (split[0] !== this.accountName) {
            this.confPost.getPartnerByName('admin-' + split[0]).subscribe(response => {
              const associateDialogRef = this.dialog.open(AssociateWithGroupComponent, {
                width: '60%'
              });
              associateDialogRef.afterClosed().subscribe(decision => {
                if (decision && decision === 'yes') {
                  const dialogRef = this.dialog.open(VerifyCredentialsComponent, {
                    data: {
                      partnerData: response,
                      partnerShortCode: split[0]
                    },
                    width: '50%'
                  });
                  dialogRef.afterClosed().subscribe(resp1 => {
                    if (resp1 && resp1 === 'valid') {
                      this.postKongDetails(this.data['id'], this.formResponse, type);
                    }
                  });
                } else if (decision && decision === 'create') {
                  this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                  this.postKongDetails(this.data['id'], this.formResponse, type);
                }
              });
            }, error => {
              if (error.status === 404) {
                this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                this.postKongDetails(this.data['id'], this.formResponse, type);
              } else {
                this.platform.openSnackBar('Error while creating the group. Please try again after sometime.', 'Error', {
                  duration: 3000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.dialogRef.close('acls');
              }
            });
          } else {
            const associateDialogRef = this.dialog.open(AssociateWithGroupComponent, {
              width: '60%'
            });
            associateDialogRef.afterClosed().subscribe(decision => {
              if (decision && decision === 'yes') {
                this.postKongDetails(this.data['id'], this.formResponse, type);
              } else if (decision && decision === 'create') {
                this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                this.postKongDetails(this.data['id'], this.formResponse, type);
              }
            });
          }
        } else {
          this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
          this.postKongDetails(this.data['id'], this.formResponse, type);
        }
        break;
      case 'consumer':
        if (this.formResponse['username'] && this.formResponse['username'] !== undefined) {
          this.formResponse['username']=this.formResponse['username'].trim();
          for (const attr of this.data.attributes) {
            if (this.formResponse[attr['name']] === '') {
              delete this.formResponse[attr['name']];
            }
          }
          const temp = [this.accountName];
          this.formResponse['custom_id'] = this.formResponse['username'];
          this.formResponse['tags'] = temp.concat(this.chipItems);
          this.kongService.createConsumerToKong(this.formResponse).subscribe(response => {
                if (response) {
                  this.postKongDetails(response['id'], {}, 'key-auth');
                  this.dialogRef.close('consumers');
                  this.platform.openSnackBar('Consumer created', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                }
              }, error => {
                this.platform.openSnackBar('Error while creating the consumer: ' + error['error']['name'], 'Error', {
                  duration: 3000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              }
          );
        } else {
          this.platform.openSnackBar('Please enter valid credential ', 'Error', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        break;
    }

  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.chipItems.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }


  }

  remove(uri): void {
    const index = this.chipItems.indexOf(uri);

    if (index >= 0) {
      this.chipItems.splice(index, 1);
    }
  }

  selectedJwtAlgorithm(event) {
    this.formResponse['algorithm'] = this.selectedJWTAlgo;
  }

  closeDialog() {
    this.dialogRef.close('');
  }
}
